import CryptoJS from "crypto-js";

function getEnvValue(primaryKey) {
  return process.env[primaryKey];
}

function hashTokenWithDateTime(authToken) {
  try {
    const keyValue = getEnvValue("REACT_APP_ENC_KEY");
    const ivValue = getEnvValue("REACT_APP_ENC_IV");
    

    if (!keyValue || !ivValue) {
      throw new Error("Encryption key/iv not found in environment variables.");
    }

    const key = CryptoJS.enc.Utf8.parse(keyValue);
    const iv = CryptoJS.enc.Utf8.parse(ivValue);

    if (!authToken) {
      throw new Error("Auth Token not found!");
    }

    const datetime = new Date().toISOString();
    const dataToEncrypt = {
      authToken,
      dateTime: datetime,
    };

    const encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(dataToEncrypt),
      key,
      { iv }
    ).toString();

    return encodeURIComponent(encryptedData);
  } catch (error) {
    console.error("Encryption failed:", error);
    throw error;
  }
}

export default hashTokenWithDateTime;